import { render, staticRenderFns } from "./AuditHistory.vue?vue&type=template&id=5f895744&"
import script from "./AuditHistory.vue?vue&type=script&lang=ts&"
export * from "./AuditHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AuditHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports